import { render, staticRenderFns } from "./MapLoader.vue?vue&type=template&id=5dd1fa90&"
import script from "./MapLoader.vue?vue&type=script&lang=ts&"
export * from "./MapLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports